module.exports = __webpack_public_path__ + "img/active-weixin.b73fd7fe.png";